import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";
import styles from "./quoteExtendBtn.module.css";
import { useStores } from "stores";
import { QuoteExtendModal } from "./QuoteExtendModal";
import { ReactComponent as RotateIcon } from "images/rotate.svg";

export const QuoteExtendBtn = observer(({ quoteExpTime, id }: { quoteExpTime: string; id: string }) => {
  const { actionModals } = useStores();
  const openModalHandler = () => {
    actionModals.open(() => <QuoteExtendModal quoteExpTime={quoteExpTime} id={id} />, {
      title: "Продлить котировку",
      width: "600px",
    });
  };
  return (
    <CustomButton
      className={styles.quoteExtendBtn}
      onClick={openModalHandler}
      icon={<RotateIcon style={{ width: 16, height: 16 }} />}
      size="small"
      tooltip="Продлить котировку"
      variant="outlined"
    />
  );
});
